module.exports = __webpack_public_path__ + "img/eopen-logo.2c1fc1d2.png";